import { Flex } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { EpisodeContext } from '@/components/ui/features/originals/EpisodesSection/components/EpisodeContext';
import { EpisodeDetails } from '@/components/ui/features/originals/EpisodesSection/components/EpisodeDetails';
import { EpisodeList } from '@/components/ui/features/originals/EpisodesSection/components/EpisodeList';
import { ErrorFallback } from '@/components/ui/shared/overlays/ErrorFallback/ErrorFallback';
import { OriginalsSection } from '@/components/ui/shared/sections/OriginalsSection/OriginalsSection';
import { BugsnagErrorBoundary } from '@/components/ui/shared/utilities/BugsnagErrorBoundary/BugsnagErrorBoundary';

export const EpisodesSection: FC = () => {
  const { t } = useTranslation();

  return (
    <EpisodeContext>
      <OriginalsSection title={t('originals.episodesSection.title')}>
        <Flex flexDirection={{ base: 'column', md: 'row' }} gridGap="5">
          <BugsnagErrorBoundary FallbackComponent={ErrorFallback}>
            <EpisodeDetails flex="1" w="full" />
          </BugsnagErrorBoundary>
          <BugsnagErrorBoundary FallbackComponent={ErrorFallback}>
            <EpisodeList flex="1" />
          </BugsnagErrorBoundary>
        </Flex>
      </OriginalsSection>
    </EpisodeContext>
  );
};
